const orgSchema = {
  '$id': '/org',
  title: 'Organization',
  type: 'object',
  properties: {
    id: { 'type': 'string', 'format': 'uuid', 'readOnly': true },
    config: { 'type': 'object' },
    created: { 'type': 'string', format: 'date-time', 'readOnly': true },
    createdBy: { 'type': 'string', 'format': 'uuid', 'readOnly': true },
    locations: { 'type': 'array', items: { type: 'object' }, 'readOnly': true },
    market: { 'type': 'number' },
    modified: { 'type': 'string', format: 'date-time', 'readOnly': true },
    modifiedBy: { 'type': 'string', 'format': 'uuid', 'readOnly': true },
    name: { 'type': 'string', minLength: 1, maxLength: 255 },
    notes: { 'type': 'string', maxLength: 255 },
    orgType: { 'type': 'string' },
    persons: { 'type': 'array', items: { type: 'object' }, 'readOnly': true },
    shortName: { 'type': 'string', maxLength: 255 },
    status: { 'type': 'number', 'readOnly': true },
    webUrl: { 'type': 'string', maxLength: 255 },
    stripeCustomerId: { 'type': 'string' },
    license: { 'type': 'string' }
  },
  'required': [
    'name',
  ],
  'additionalProperties': false
}

export default orgSchema
